<template>
  <div id="app">
    <div id="nav">
      <router-link to="/"></router-link>
    </div>
    <router-view />
  </div>
</template>
<script>
import dayjs from "dayjs";
import { addLogininfor } from "@/api/home/nav";

export default {
  data() {
    return {
      beforeUnloadTime: 0,
      unloadTime: 0,
      starttime: 0,
      Information: null,
    };
  },
  created() {
    if (sessionStorage.getItem("userInfo")) {
      let infor = JSON.parse(sessionStorage.getItem("userInfo"));
      if (infor !== null) {
        this.Information = infor;
      }
    }
  },
  mounted() {
    window.addEventListener("beforeunload", () => this.beforeunloadHandler());
    window.addEventListener("unload", () => this.unloadHandler());
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
  destroyed() {
    window.removeEventListener("beforeunload", () =>
      this.beforeunloadHandler()
    );
    window.removeEventListener("unload", () => this.unloadHandler());
  },
  methods: {
    async addlog() {
      let obj1 = {
        userName: this.Information.userName,
        msg: "退出成功",
        loginTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      };
      sessionStorage.removeItem("userInfo");
      sessionStorage.removeItem("activeIndex");
      sessionStorage.removeItem("nextLevel");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("autonomous");
      sessionStorage.removeItem("headImg");
      sessionStorage.removeItem("courseDetail");
      await addLogininfor(obj1);
    },
    beforeunloadHandler() {
      this.beforeUnloadTime = new Date().getTime();
    },
    unloadHandler() {
      this.unloadTime = new Date().getTime() - this.beforeUnloadTime;
      //判断是窗口关闭还是刷新
      if (this.unloadTime <= 5) {
        if (this.Information !== null) {
          this.addlog();
        }
      }
    },
  },
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
body {
  overflow-x: hidden;
}
body::-webkit-scrollbar {
  width: 4px;
  height: 12px;
}
body::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
body::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
body::-webkit-scrollbar-thumb:hover {
  background: #888;
}

#app {
  width: 100%;
  height: 100%;
}
ul {
  margin: 0;
  padding: 0;
}
</style>
